"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterAndSortOptions = void 0;
var _lodash = require("lodash");
var _constants = require("../constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sortReactSelectOptions = function sortReactSelectOptions(searchValue) {
  return function (a, b) {
    var compareStringA = a.label;
    var compareStringB = b.label;
    if (compareStringA.startsWith(searchValue) && !compareStringB.startsWith(searchValue)) {
      return -1;
    }
    if (compareStringB.startsWith(searchValue) && !compareStringA.startsWith(searchValue)) {
      return 1;
    }
    return compareStringA.localeCompare(compareStringB);
  };
};
var filterAndSortOptions = function filterAndSortOptions(groupedOptions, searchValue) {
  var matchedPopularOptions = (0, _lodash.filter)(groupedOptions[0].options, function (option) {
    return (0, _lodash.includes)(option.label, searchValue);
  });
  var matchedAllOptions = (0, _lodash.filter)(groupedOptions[1].options, function (option) {
    return (0, _lodash.includes)(option.label, searchValue);
  });
  matchedPopularOptions.sort(sortReactSelectOptions(searchValue));
  matchedAllOptions.sort(sortReactSelectOptions(searchValue));
  return [_objectSpread(_objectSpread({}, _constants.SELECT_PAYER_GROUPS_CONFIG.POPULAR), {}, {
    options: matchedPopularOptions
  }), _objectSpread(_objectSpread({}, _constants.SELECT_PAYER_GROUPS_CONFIG.ALL), {}, {
    options: matchedAllOptions
  })];
};
exports.filterAndSortOptions = filterAndSortOptions;